import { PaginationContext } from "./chunk-6MXG22MP.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Pagination/Pagination.tsx
import React, { useMemo } from "react";
import clsx from "clsx";
var Pagination = _a => {
  var _b = _a,
    {
      children,
      total,
      perPage = 10,
      siblingPages = 2,
      currentPage = 1,
      className
    } = _b,
    rest = __objRest(_b, ["children", "total", "perPage", "siblingPages", "currentPage", "className"]);
  const totalPages = useMemo(() => Math.ceil(total / perPage), [total, perPage]);
  const pages = useMemo(() => Array.from({
    length: totalPages
  }, (_, index) => index + 1), [totalPages]);
  const context = useMemo(() => ({
    total,
    perPage,
    siblingPages,
    currentPage,
    totalPages,
    pages
  }), [total, perPage, siblingPages, currentPage, totalPages, pages]);
  if (totalPages <= 1) {
    return null;
  }
  return /* @__PURE__ */React.createElement(PaginationContext.Provider, {
    value: context
  }, /* @__PURE__ */React.createElement("nav", __spreadValues({
    className: clsx("pd-pagination", className)
  }, rest), children(context)));
};
var Pagination_default = Pagination;
export { Pagination_default };